module.exports = __webpack_public_path__ + "static/img/login1.695ac1a3.png";